import Mapbox from 'index.vue';
import { BaseFeatureLayer } from './baseFeatureLayer';

export class SearchResultsLayer extends BaseFeatureLayer {
    constructor(mapboxInstance: InstanceType<typeof Mapbox>) {
        super(mapboxInstance, '', 'searchresults-circle-layer', 'searchresults-circle-source','symbol', {
            'icon-image': ['get', 'url'],
            'icon-size': ['/', ['get', 'size'], 1],
            'icon-allow-overlap': true,
            'icon-anchor': 'top-left',
            'icon-offset': [-26,-26],
            'symbol-sort-key': ['get', 'zIndex'],
        }, {
            'icon-opacity': 0.75, // <- Set opacity here (0 = fully transparent, 1 = fully opaque)
        }, true);

        this.mapboxInstance.map.on('click', this.layerName, (e: any) => {
            e.features.sort((a: any, b: any) => (b.properties.zIndex || 0) - (a.properties.zIndex || 0));
            const feature = e.features[0];
            const [longitude, latitude] = feature.geometry.coordinates;
            this.mapboxInstance.$emit('searchResultLeftClick', {
                x: e.point.x,
                y: e.point.y,
                latitude: latitude,
                longitude: longitude,
                name: feature.properties.name,
            });
        });
    }

    public DataChanged = async () => {
        const uniqueUrls = new Set<string>();
        if (this.mapboxInstance.searchResults != null) {
            this.mapboxInstance.searchResults.forEach((searchResult: any) => {
                uniqueUrls.add('/api/search/category-logo?category=' + searchResult.category);
            });

            const loadImagePromises = this.LoadImages(uniqueUrls);
            const features = this.mapboxInstance.searchResults.map((searchResult: any) => {
                return {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [searchResult.longitude, searchResult.latitude] as [number, number],
                    },
                    properties: {
                        url: '/api/search/category-logo?category=' + searchResult.category,
                        icon: searchResult.icon,
                        zIndex: 1,
                        size: 0.65,
                        title: searchResult.title + ' (' + searchResult.category + ')',
                        name: searchResult.title,
                    }
                }
            });
            await Promise.all(loadImagePromises);
            this.SetFeatures(features);
        }
    };
}